import { render, staticRenderFns } from "./jyj_shixi.vue?vue&type=template&id=ab00853c&scoped=true"
import script from "./jyj_shixi.vue?vue&type=script&lang=js"
export * from "./jyj_shixi.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!E:\\SAAS-QSX-JYJ\\WEB\\node_modules\\_vue-loader@15.11.1@vue-loader\\lib\\runtime\\componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab00853c",
  null
  
)

export default component.exports